import { Info } from 'lucide-react'
import { Tooltip } from './Tooltip'

interface InfoTooltipProps {
  children: string
  label?: string
}

/**
 * Klein i-icoontje voor toelichting bij een veld dat zelf geen ruimte heeft voor
 * uitleg, zoals een smal getalveld. Toetsenbordbereikbaar en verbergt niets:
 * de uitleg staat er altijd, alleen pas zichtbaar bij hover of focus.
 */
export function InfoTooltip({ children, label = 'Meer uitleg' }: InfoTooltipProps) {
  return (
    <Tooltip content={children}>
      <button
        type="button"
        aria-label={label}
        className="-my-px inline-flex h-3 w-3 shrink-0 translate-y-px items-center justify-center rounded-full text-ink-faint transition-colors duration-150 hover:text-ink-soft focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primair-500/40"
      >
        <Info className="h-3 w-3" strokeWidth={2} />
      </button>
    </Tooltip>
  )
}
